import * as yup from 'yup';

export const AddRegionSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});

export const UpdateRegionSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
});
